import React from 'react';
import './ShopCategoryPage.css';
import { useNavigate } from 'react-router-dom';
import { playSound } from '../utils/soundPlayer';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { getLoggedInUser } from '../logic/loginLogic';
import { doc, onSnapshot, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { normalizePhoneNumber, validatePhoneNumberUniqueness, validatePhoneNumberFormat } from '../utils/phoneValidation';
import { useNotification } from '../contexts/NotificationContext';
import { logFinancialEvent, logUserAction, EVENT_TYPES } from '../utils/securityLogger';
import OCGIcon from '../assets/icons/ocg.webp';
import TCGIcon from '../assets/icons/tcg.webp';
import AccessIcon from '../assets/icons/accessories.png';
import MiscIcon from '../assets/icons/misc.webp';
import MarketIcon from '../assets/icons/market.png';
import BuyDPLogo from '../assets/icons/buydp.png'; // replace with your actual icon path





const ShopCategoryPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showTransactionPending, showTransactionSuccess, showTransactionFailed } = useNotification();
  const [dp, setDp] = useState(null);
  const [pseudo, setPseudo] = useState('');
  const [userId, setUserId] = useState(null);
  const [dpOptions, setDpOptions] = useState([]);
  const [showMvolaModal, setShowMvolaModal] = useState(false);
  const [selectedMvolaOption, setSelectedMvolaOption] = useState(null);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userRegisteredPhone, setUserRegisteredPhone] = useState('');
  
  // Pre-fill phone number when modal opens
  useEffect(() => {
    if (showPhoneModal && userRegisteredPhone) {
      setPhoneNumber(userRegisteredPhone);
      setPhoneNumberError(''); // Clear error when modal opens
    }
  }, [showPhoneModal, userRegisteredPhone]);
  const [dpInstructions, setDpInstructions] = useState([]);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false); // Add this line
  const [timeoutId, setTimeoutId] = useState(null); // Track timeout ID
  const [phoneNumberError, setPhoneNumberError] = useState(''); // Track phone number validation error






  useEffect(() => {
    const fetchDPOptions = async () => {
      try {
        const docRef = doc(db, 'settings', 'dpOptions');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setDpOptions(docSnap.data().options || []);
          setDpInstructions(data.instructionsList || []);
        } else {
          console.log('No dpOptions found in Firestore');
        }
      } catch (error) {
        console.error('Error fetching dpOptions:', error);
      }
    };

    fetchDPOptions();
  }, []);

  useEffect(() => {
    const user = getLoggedInUser();
    if (user) {
      setUserId(user.uid);
    }
  }, []);
  useEffect(() => {
    if (!userId) return;

    const unsubscribe = onSnapshot(doc(db, 'users', userId), (docSnap) => {
      if (docSnap.exists()) {
        const userData = docSnap.data();
        const newDp = userData.dp || 0;
        const oldDp = dp;
        
        setDp(newDp);
        setPseudo(userData.pseudo || 'Duelist');
        setUserRegisteredPhone(userData.phoneNumber || '');
        
        // Note: DP increase detection removed - now handled by proper transaction status checking
        
        // Note: Additional DP increase detection removed - now handled by proper transaction status checking
      } else {
        console.log('User not found in Firestore');
      }
    });

    return () => unsubscribe();
  }, [userId, dp, showTransactionSuccess, timeoutId]);

  // Add polling mechanism to check for successful transactions
  useEffect(() => {
    if (!timeoutId || !userId) return;
    
    console.log('🔄 Starting transaction polling...');
    const pollInterval = setInterval(async () => {
      try {
        // Check user's current DP from Firestore
        const userRef = doc(db, 'users', userId);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          const currentDp = userData.dp || 0;
          
          console.log(`🔍 Polling check: current DP = ${currentDp}, stored DP = ${dp}`);
          
          // If DP has increased, transaction was successful
          if (currentDp > dp) {
            const dpAdded = currentDp - dp;
            console.log(`✅ Polling detected DP increase: +${dpAdded} DP`);
            showTransactionSuccess(dpAdded);
            setIsPaymentProcessing(false);
            
            // Clear timeout and polling
            clearTimeout(timeoutId);
            setTimeoutId(null);
            clearInterval(pollInterval);
          }
        }
      } catch (error) {
        console.error('Error polling for transaction:', error);
      }
    }, 3000); // Check every 3 seconds (faster polling)
    
    return () => {
      clearInterval(pollInterval);
    };
  }, [timeoutId, userId, dp, showTransactionSuccess]);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);


  const goTo = (path) => {
    playSound('menu');
    navigate(path);
  };

  return (
    <div className="shop-category-container">
      <div className="shop-category-header">
        <h1 className="shop-category-title">{t('shopCategory.title')}</h1>
      </div>

      <div className="shop-category-grid">

        <div className="panel mvola-panel" onClick={() => setShowMvolaModal(true)}>
              <img
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                src={BuyDPLogo}
                alt="Buy DP via MVola"
            className="panel-icon"
              />
          <div className="panel-label">
            <div>{t('shopCategory.buyDPViaMvolaLabel', 'BUY DP VIA MVOLA')}</div>
          </div>
        </div>

        <div className="panel shop-panel" onClick={() => goTo('/shop/ocg')}>
              <img
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                draggable={false}
            src={OCGIcon}
            alt="OCG"
            className="panel-icon"
          />
          <div className="panel-label">
            <div>{t('shopCategory.ocg')}</div>
          </div>
        </div>

        <div className="panel shop-panel" onClick={() => goTo('/shop/tcg')}>
              <img
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                draggable={false}
            src={TCGIcon}
            alt="TCG"
            className="panel-icon"
          />
          <div className="panel-label">
            <div>{t('shopCategory.tcg')}</div>
          </div>
        </div>

        <div className="panel shop-panel" onClick={() => goTo('/shop/accessories')}>
              <img
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                draggable={false}
            src={AccessIcon}
            alt="Accessories"
            className="panel-icon"
          />
          <div className="panel-label">
            <div>{t('shopCategory.accessories')}</div>
          </div>
        </div>

        <div className="panel shop-panel" onClick={() => goTo('/shop/misc')}>
              <img
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                draggable={false}
            src={MiscIcon}
            alt="Misc"
            className="panel-icon"
          />
          <div className="panel-label">
            <div>{t('shopCategory.misc')}</div>
          </div>
        </div>

        <div className="communityMarket disabled" style={{opacity: 0.5, cursor: 'not-allowed'}}>
              <img
                onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                onTouchStart={(e) => e.preventDefault()}
                draggable={false}
            src={MarketIcon}
            alt="Community Market"
            className="panel-icon"
          />
          <div className="panel-label">
            <div>{t('shopCategory.marketplace')}</div>
            <div style={{fontSize: '0.8em', color: '#888', marginTop: '4px'}}>{t('shopCategory.comingSoon')}</div>
          </div>
        </div>



      </div>

      <button className="back-button-fixed" onClick={() => {
        playSound('return');
        navigate('/menu');
      }}>
        {t('buttons.menu')}
      </button>


      {showMvolaModal && (
        <div className="mvola-modal-overlay" onClick={() => setShowMvolaModal(false)}>
          <div className="mvola-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="mvola-title">
                {t('shopCategory.buyDPViaMvolaLabel', 'BUY DP VIA MVOLA')}
              </h2>

            <ul className="mvola-options">
                  {dpOptions.length > 0 ? (
                    dpOptions.map((amount, index) => (
                  <li
                        key={index}
                    className="mvola-option clickable"
                        onClick={() => {
                          setSelectedMvolaOption(amount);
                          setShowPhoneModal(true);
                        }}
                      >
                    {amount}
                  </li>
                    ))
                  ) : (
                <li className="mvola-option">{t('shopCategory.loadingDPOptions')}</li>
                  )}
            </ul>

            <div className="mvola-instruction-text">
              <strong>{t('shopCategory.instructionsTitle')}</strong>
              <ul className="dp-instruction-list">
                  {dpInstructions.length > 0 ? (
                  dpInstructions.map((line, index) => <li key={index}>{line}</li>)
                  ) : (
                  <li>{t('shopCategory.instructionsNotAvailable')}</li>
                  )}
              </ul>
            </div>

            <button className="mvola-close-button" onClick={() => setShowMvolaModal(false)}>
              {t('shopCategory.close', 'Close')}
            </button>
          </div>
        </div>
      )}


      {showPhoneModal && (
         <div className="dp-modal-overlay" onClick={() => setShowPhoneModal(false)}>
          <div className="dp-modal" onClick={(e) => e.stopPropagation()}>
            <h2>{t('shopCategory.enterPhoneNumber', 'Pay via Mvola')}</h2>

            {!userRegisteredPhone ? (
              // Simplified UI when phone number is not set
              <>
                <div className="phone-not-set-message">
                  <div className="warning-icon">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L2 20h20L12 2z" fill="#ffa726" stroke="#ff9800" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 9v4M12 17h.01" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <p className="message-text">
                    {t('shopCategory.phoneNotSetMessage')}
                  </p>
                </div>
                <div className="phone-modal-buttons">
                  <button
                    className="confirm-button"
                    onClick={() => {
                      setShowPhoneModal(false);
                      setShowMvolaModal(false);
                      navigate('/account-settings');
                    }}
                  >
                    {t('shopCategory.goToAccountSettings')}
                  </button>
                  <button className="close-modal" onClick={() => setShowPhoneModal(false)}>
                    {t('shopCategory.close', 'Close')}
                  </button>
                </div>
              </>
            ) : (
              // Original UI when phone number is set
              <>
                <p><strong>{t('shopCategory.selectedPackage')}:</strong> {selectedMvolaOption}</p>
                <p><strong>{t('shopCategory.paymentMethod')}:</strong> MVola Mobile Money</p>

                <div className="phone-input-container">
                  <label htmlFor="mvola-phone" className="phone-input-label">
                    {t('shopCategory.mvolaPhoneNumber')}:
                  </label>
                  <input
                    id="mvola-phone"
                    type="tel"
                    placeholder={userRegisteredPhone || t('shopCategory.phonePlaceholder', 'Enter your MVola phone number (e.g., 0341234567)')}
                    value={phoneNumber}
                    onChange={(e) => {
                      setPhoneNumber(e.target.value);
                      setPhoneNumberError(''); // Clear error on change
                    }}
                  />
                  {phoneNumberError && (
                    <div style={{ color: '#ff6b6b', fontSize: '12px', marginTop: '5px' }}>
                      {phoneNumberError}
                    </div>
                  )}
                </div>

                <div className="phone-modal-buttons">
                <button
                  className={`confirm-button ${isPaymentProcessing ? 'disabled' : ''} ${!userRegisteredPhone ? 'register-phone-button' : ''}`}
                  disabled={isPaymentProcessing}
                  onClick={async () => {
                    try {
                      if (isPaymentProcessing) return; // Prevent multiple clicks
                      
                      // If user doesn't have a registered phone number, navigate to account settings
                      if (!userRegisteredPhone) {
                        setShowPhoneModal(false);
                        setShowMvolaModal(false);
                        navigate('/account-settings');
                        return;
                      }
                      
                      
                      // Validate that phone number matches registered phone
                      if (phoneNumber.trim() !== userRegisteredPhone.trim()) {
                        setPhoneNumberError(t('shopCategory.wrongNumberError'));
                        return;
                      }
                      if (!phoneNumber.trim()) {
                     alert(t('shopCategory.phoneRequired'));
                        return;
                      }
                      if (!userId) {
                     alert(t('shopCategory.authRequired'));
                        return;
                      }
                      
                      // Validate phone number format
                      if (!validatePhoneNumberFormat(phoneNumber)) {
                     alert(t('shopCategory.invalidPhoneFormat'));
                        return;
                      }
                      
                      // Validate that phone number is not registered to another user
                      const normalizedInputPhone = normalizePhoneNumber(phoneNumber);
                      const uniquenessResult = await validatePhoneNumberUniqueness(normalizedInputPhone, userId);
                      
                      if (!uniquenessResult.isUnique) {
                     alert(`${t('shopCategory.securityVerificationFailed')}: ${uniquenessResult.message}. ${t('shopCategory.useDifferentNumber')}`);
                        return;
                      }
                      
                      setIsPaymentProcessing(true); // Disable button
                      
                      // Clear any existing timeout before starting new payment
                      if (timeoutId) {
                        clearTimeout(timeoutId);
                        setTimeoutId(null);
                      }
                      
                      // Log MVola purchase initiation
                      await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_INITIATED, userId, selectedMvolaOption, {
                        purchaseMethod: 'mvola',
                        phoneNumber: phoneNumber,
                        dpAmount: selectedMvolaOption,
                        paymentProvider: 'MVola'
                      });
                      
                      console.log('📤 Sending MVola payment request:', {
                        userId,
                        option: selectedMvolaOption,
                        phone: phoneNumber
                      });
                      
                      const response = await fetch('https://us-central1-yme-dp-manager.cloudfunctions.net/mvolaPayment', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          userId,
                          option: selectedMvolaOption,
                          phone: phoneNumber,
                        }),
                      });

                      const result = await response.json();
                      if (result.success) {
                        // Log successful MVola purchase
                        await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_SUCCESS, userId, selectedMvolaOption, {
                          purchaseMethod: 'mvola',
                          phoneNumber: phoneNumber,
                          dpAmount: selectedMvolaOption,
                          paymentProvider: 'MVola',
                          transactionId: result.transactionId || 'N/A'
                        });

                        // Log user action
                        await logUserAction('MVOLA_PURCHASE', userId, {
                          phoneNumber: phoneNumber,
                          dpAmount: selectedMvolaOption,
                          paymentProvider: 'MVola'
                        });

                        // Close ALL modals immediately and show notification
                        setShowPhoneModal(false);
                        setShowMvolaModal(false);
                        setPhoneNumber('');
                        
                        // Show transaction in progress notification
                        showTransactionPending(result.dpAmount);
                        
                        // Get initial DP immediately for comparison
                        const getInitialDP = async () => {
                          try {
                            const userResponse = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/getUserData`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ userId: userId })
                            });
                            
                            if (userResponse.ok) {
                              const userData = await userResponse.json();
                              window.initialDP = userData.user?.dp || 0;
                              console.log(`🔍 Stored initial DP: ${window.initialDP}`);
                            }
                          } catch (error) {
                            console.error('Error getting initial DP:', error);
                            window.initialDP = 0; // Fallback
                          }
                        };
                        
                        // Get initial DP immediately
                        await getInitialDP();
                        
                        // Start polling for transaction status using the new checkTransactionStatus function
                        const pollTransactionStatus = async () => {
                          try {
                            // AGGRESSIVE DP CHECK: Use dedicated DP increase checking endpoint
                            console.log(`🔍 Polling: Checking DP increase (Initial: ${window.initialDP}, Expected: ${selectedMvolaOption})`);
                            
                            const dpCheckResponse = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/checkDPIncrease`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                userId: userId,
                                expectedAmount: selectedMvolaOption,
                                initialDP: window.initialDP
                              })
                            });
                            
                            if (dpCheckResponse.ok) {
                              const dpCheckResult = await dpCheckResponse.json();
                              console.log(`🔍 DP Check Result:`, dpCheckResult);
                              
                                if (dpCheckResult.success && dpCheckResult.status === 'Completed') {
                                  console.log(`✅ SUCCESS: DP increase detected via dedicated endpoint!`);
                                  clearInterval(pollInterval);
                                  clearTimeout(dpTimeoutId); // Clear DP timeout
                                  // Show the actual amount that was added, not the total DP
                                  showTransactionSuccess(dpCheckResult.dpIncrease);
                                  setIsPaymentProcessing(false);
                                  if (timeoutId) {
                                    clearTimeout(timeoutId);
                                    setTimeoutId(null);
                                  }
                                  return;
                                }
                            } else {
                              console.log(`❌ DP Check failed: ${dpCheckResponse.status}`);
                            }
                            
                            // FALLBACK: Direct DP check as backup
                            try {
                              const userResponse = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/getUserData`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ userId: userId })
                              });
                              
                              if (userResponse.ok) {
                                const userData = await userResponse.json();
                                const currentDP = userData.user?.dp || 0;
                                const dpIncrease = currentDP - window.initialDP;
                                
                                console.log(`🔍 FALLBACK DP Check: Current=${currentDP}, Initial=${window.initialDP}, Increase=${dpIncrease}`);
                                
                                // Only show success if DP increased by expected amount or close to it
                                if (dpIncrease >= selectedMvolaOption || (dpIncrease > 0 && dpIncrease >= (selectedMvolaOption * 0.9))) {
                                  console.log(`✅ FALLBACK SUCCESS: DP increased by ${dpIncrease} (expected: ${selectedMvolaOption}), showing success banner`);
                                  clearInterval(pollInterval);
                                  clearTimeout(dpTimeoutId); // Clear DP timeout
                                  // Show the actual amount that was added, not the total DP
                                  showTransactionSuccess(dpIncrease);
                                  setIsPaymentProcessing(false);
                                  if (timeoutId) {
                                    clearTimeout(timeoutId);
                                    setTimeoutId(null);
                                  }
                                  return;
                                }
                              }
                            } catch (error) {
                              console.error('Fallback DP check error:', error);
                            }
                            
                            const statusResponse = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/checkTransactionStatus`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                userId: userId,
                                referenceId: result.referenceId
                              })
                            });
                            const statusResult = await statusResponse.json();
                            
                            if (statusResult.success) {
                              console.log(`🔍 Transaction status check: ${statusResult.status} - ${statusResult.message}`);
                              
                              if (statusResult.status === 'Completed') {
                                // Transaction completed successfully
                                console.log(`✅ Transaction completed successfully: ${result.dpAmount} DP`);
                                clearInterval(pollInterval); // Stop polling
                                clearTimeout(dpTimeoutId); // Clear DP timeout
                                showTransactionSuccess(result.dpAmount);
                                setIsPaymentProcessing(false);
                                if (timeoutId) {
                                  clearTimeout(timeoutId);
                                  setTimeoutId(null);
                                }
                                return;
                              } else if (statusResult.status === 'Failed' || statusResult.status === 'Cancelled') {
                                // Transaction failed or was cancelled
                                console.log(`❌ Transaction failed/cancelled: ${statusResult.message}`);
                                clearInterval(pollInterval); // Stop polling
                                clearTimeout(dpTimeoutId); // Clear DP timeout
                                showTransactionFailed(result.dpAmount);
                                setIsPaymentProcessing(false);
                                if (timeoutId) {
                                  clearTimeout(timeoutId);
                                  setTimeoutId(null);
                                }
                                return;
                              } else if (statusResult.status === 'PENDING') {
                                console.log(`⏳ Transaction still pending...`);
                              } else {
                                // Handle any other status
                                console.log(`🔍 Unknown status received: ${statusResult.status}`);
                              }
                              // If status is still 'PENDING' or unknown, continue polling
                            } else {
                              console.log(`❌ Status check failed: ${statusResult.message}`);
                              // Don't stop polling on API errors - let it continue
                            }
                          } catch (error) {
                            console.error('Error checking transaction status:', error);
                            // Don't clear interval on error - let it continue polling
                          }
                        };
                        
                        // Poll every 2 seconds for very fast response to successful transactions
                        const pollInterval = setInterval(pollTransactionStatus, 2000);
                        
                        // Add a shorter timeout for DP increase detection (30 seconds)
                        // If no DP increase is detected within 30 seconds, likely the transaction was cancelled
                        const dpTimeoutId = setTimeout(() => {
                          console.log(`⏰ DP Timeout: No DP increase detected within 30 seconds, likely cancelled`);
                          clearInterval(pollInterval);
                          showTransactionFailed(selectedMvolaOption);
                          setIsPaymentProcessing(false);
                          if (timeoutId) {
                            clearTimeout(timeoutId);
                            setTimeoutId(null);
                          }
                        }, 30000); // 30 seconds
                        
                        // Set timeout for failed transaction (120 seconds) and store the ID
                        // Increased timeout to allow for webhook processing time
                        const newTimeoutId = setTimeout(async () => {
                          clearInterval(pollInterval);
                          
                          // Final check using the new status checker before showing failure
                          try {
                            const finalStatusResponse = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/checkTransactionStatus`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                userId: userId,
                                referenceId: result.referenceId
                              })
                            });
                            const finalStatusResult = await finalStatusResponse.json();
                            
                            if (finalStatusResult.success) {
                              console.log(`🔍 Final timeout status check: ${finalStatusResult.status} - ${finalStatusResult.message}`);
                              
                              if (finalStatusResult.status === 'Completed') {
                                console.log(`✅ Final check: Transaction completed successfully`);
                                showTransactionSuccess(result.dpAmount);
                              } else if (finalStatusResult.status === 'Failed' || finalStatusResult.status === 'Cancelled') {
                                console.log(`❌ Final check: Transaction failed/cancelled`);
                                showTransactionFailed(result.dpAmount);
                              } else if (finalStatusResult.status === 'PENDING') {
                                console.log(`⏳ Final check: Transaction still pending after timeout, showing failure`);
                                showTransactionFailed(result.dpAmount);
                              } else {
                                console.log(`❌ Final check: Unknown status (${finalStatusResult.status}), showing failure`);
                                showTransactionFailed(result.dpAmount);
                              }
                            } else {
                              console.log(`❌ Final check: Status check failed, showing failure`);
                              showTransactionFailed(result.dpAmount);
                            }
                          } catch (error) {
                            console.error('Error in final status check:', error);
                            showTransactionFailed(result.dpAmount);
                          }
                          
                          setIsPaymentProcessing(false); // Re-enable button after timeout
                          setTimeoutId(null); // Clear the timeout ID
                        }, 120000); // 120 seconds timeout (2 minutes)
                        setTimeoutId(newTimeoutId);
                      } else {
                        // Log failed MVola purchase
                        await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_FAILED, userId, selectedMvolaOption, {
                          purchaseMethod: 'mvola',
                          phoneNumber: phoneNumber,
                          dpAmount: selectedMvolaOption,
                          paymentProvider: 'MVola',
                          error: result.message || 'Payment failed'
                        });

                     alert(`${t('shopCategory.transactionFailed')}: ${result.message}`);
                        setIsPaymentProcessing(false); // Re-enable button on failure
                        
                        // Clear any pending timeout since payment failed immediately
                        if (timeoutId) {
                          clearTimeout(timeoutId);
                          setTimeoutId(null);
                        }
                      }
                    } catch (error) {
                      console.error('Error:', error);
                      
                      // Log error in MVola purchase
                      await logFinancialEvent(EVENT_TYPES.DP_PURCHASE_FAILED, userId, selectedMvolaOption, {
                        purchaseMethod: 'mvola',
                        phoneNumber: phoneNumber,
                        dpAmount: selectedMvolaOption,
                        paymentProvider: 'MVola',
                        error: error.message || 'Unknown error'
                      });

                   alert(t('shopCategory.initializationFailed'));
                      setIsPaymentProcessing(false); // Re-enable button on error
                      
                      // Clear any pending timeout since there was an error
                      if (timeoutId) {
                        clearTimeout(timeoutId);
                        setTimeoutId(null);
                      }
                    }
                  }}
                >
                  {isPaymentProcessing 
                    ? t('shopCategory.processingPayment', 'Processing Transaction...') 
                    : t('shopCategory.confirmPayment', 'Process Payment')
                  }
                </button>

                <button className="close-modal" onClick={() => setShowPhoneModal(false)}>
                  {t('shopCategory.close', 'Close')}
                </button>
              </div>
              </>
            )}
          </div>
        </div>
      )}




      <div className="user-info">
        ID: {pseudo || '...'}&nbsp;&nbsp;&nbsp;  {t('menu.dp')}: {dp !== null ? dp : '...'}
      </div>

    </div>
  );
};

export default ShopCategoryPage;
